import { useEffect, useState } from 'react';
import axios from 'axios';

export default function FullRankingPage() {
  const [ranking, setRanking] = useState([]);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const token = localStorage.getItem('token');
       const res = await axios.get(
  `https://nagradjivanje-api.revicon.info/questionnaire/full-ranking`,
  { headers: { Authorization: `Bearer ${token}` } }
);

        setRanking(res.data.ranking);
      } catch (err) {
        alert('Greška prilikom učitavanja rankinga.');
      }
    };
    fetchRanking();
  }, []);

  if (ranking.length === 0) return <p>Učitavanje...</p>;

  return (
    <div style={{ maxWidth: '900px', margin: '2rem auto', padding: '2rem', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#f8f9fa' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Kompletni rezultati (NEXUS)</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={th}>#</th>
            <th style={th}>Ime</th>
            <th style={th}>Email</th>
            <th style={th}>Ekonomski</th>
            <th style={th}>Upravljanje</th>
            <th style={th}>Ekologija</th>
            <th style={th}>Inovacije</th>
            <th style={th}>NEXUS</th>
          </tr>
        </thead>
        <tbody>
          {ranking.map((r, i) => (
            <tr key={i}>
              <td style={td}>{i + 1}</td>
              <td style={td}>{r.name}</td>
              <td style={td}>{r.email}</td>
              <td style={td}>{r.category1.toFixed(2)}</td>
              <td style={td}>{r.category2.toFixed(2)}</td>
              <td style={td}>{r.category3.toFixed(2)}</td>
              <td style={td}>{r.category4.toFixed(2)}</td>
              <td style={td}><strong>{r.total.toFixed(2)}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const th = { border: '1px solid #ddd', padding: '8px', background: '#eee' };
const td = { border: '1px solid #ddd', padding: '8px' };
